import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import portalSettings from './config/portal-settings.json'
import './styles/index.css'

if (portalSettings.title) {
  document.title = portalSettings.title
}
if (portalSettings.themeColor) {
  const meta = document.querySelector('meta[name="theme-color"]')
  if (meta) meta.setAttribute('content', portalSettings.themeColor)
}
if (portalSettings.favicon) {
  const icon = document.querySelector("link[rel~='icon']")
  if (icon) icon.href = portalSettings.favicon
}
if (portalSettings.appleTouchIcon) {
  const touch = document.querySelector("link[rel='apple-touch-icon']")
  if (touch) touch.href = portalSettings.appleTouchIcon
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
)